exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn_history{\n    background-color: #fff;\n    border: 1px solid #78868b;\n    border-radius: 3px;\n    color: #5e6f75;\n}\n\n.span_lg{\n    color: #5b6c72;\n    font-weight: bold;\n    font-size: 40px;\n}\n\n.span_md{\n    color: #5b6c72;\n    font-size: 16px;\n}\n\n.span_plan{\n    margin-top: 40px;\n    padding-right: 0px;\n}\n\n.span_sm{\n    color: #5b6c72;\n    font-weight: 500;\n    font-size: 18px;\n}\n\n.span_xs{\n    color: #9b9b9b;\n    font-size: 12px;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/src/app/pages/dashboard-mycredits/dashboard-mycredits.component.css
// module id = ../../../../../src/app/pages/dashboard-mycredits/dashboard-mycredits.component.css
// module chunks = main